import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from 'c-components';
import { useCommonTranslation } from 'c-translation';

type Props = {
    /** Re-runs the request. Without it the message shows on its own. */
    onRetry?: () => void;
};

/** What a chart or table shows when its request failed, as opposed to returning no rows. */
const ReportLoadFailed: React.FC<Props> = ({ onRetry }) => {
    const t = useCommonTranslation();

    return (
        <Box
            role="alert"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            py={5}
            gap={2}
            color="grey.500"
        >
            <Typography variant="h2">{t('Reporting.loadFailed')}</Typography>
            {onRetry && (
                <Button onClick={onRetry} variant="text">
                    {t('Reporting.retry')}
                </Button>
            )}
        </Box>
    );
};

export default ReportLoadFailed;
